module.exports={
	"Form": "FundViewManifest",
	"Scope": "Fund-View",
	"Descriptors":
	{
		"FundDetails.Name":
		{
			"Name": "Name",
			"Hash": "Fund-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Fund-View-Identity",
				"Group": "Fund-View-Identity"
			}
		},
		"FundDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Fund-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.Description":
		{
			"Name": "Description",
			"Hash": "Fund-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.OriginalBalance":
		{
			"Name": "Original Balance",
			"Hash": "Fund-View-OriginalBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.TotalCommitted":
		{
			"Name": "Total Committed",
			"Hash": "Fund-View-TotalCommitted",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.CommittedBalance":
		{
			"Name": "Committed Balance",
			"Hash": "Fund-View-CommittedBalance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Fund-View-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.TotalPendingCharge":
		{
			"Name": "Total Pending Charge",
			"Hash": "Fund-View-TotalPendingCharge",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.ExternalAccountID":
		{
			"Name": "External Account ID",
			"Hash": "Fund-View-ExternalAccountID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.CostCenter":
		{
			"Name": "Cost Center",
			"Hash": "Fund-View-CostCenter",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.Active":
		{
			"Name": "Active",
			"Hash": "Fund-View-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Fund-View-Details",
				"Group": "Fund-View-Details"
			}
		},
		"FundDetails.IDFund":
		{
			"Name": "IDFund",
			"Hash": "Fund-View-IDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.GUIDFund":
		{
			"Name": "GUIDFund",
			"Hash": "Fund-View-GUIDFund",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Fund-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Fund-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Fund-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		},
		"FundDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Fund-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Fund-View-DataAudit",
				"Group": "Fund-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Fund-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Fund-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Fund-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Fund-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Fund-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Fund-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
